import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import React from 'react';
import { BlankHeaderCell, HeaderCell } from './types/header.types';
import { Order } from './types/table.types';

interface SortableHeadersProps<T extends string> {
  headerCells: (HeaderCell<T> | BlankHeaderCell)[];
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
}

const StandardSortableHeaders = <T extends string>({
  headerCells,
  onRequestSort,
  order,
  orderBy,
}: SortableHeadersProps<T>) => {
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  function isBlankHeaderCell(cell: BlankHeaderCell | HeaderCell<T>) {
    return (cell as HeaderCell<T>).label === undefined;
  }

  return (
    <TableHead>
      <TableRow>
        {headerCells.map(cell => {
          if (isBlankHeaderCell(cell)) {
            return (
              <TableCell
                key={cell.key}
                align={'left'}
                padding={'none'}
                sortDirection={false}
              >
                <TableSortLabel disabled={true}></TableSortLabel>
              </TableCell>
            );
          } else {
            const headerCfg = cell as HeaderCell<T>;

            return (
              <TableCell
                key={String(headerCfg.key)}
                align={headerCfg.numeric ? 'right' : 'left'}
                padding={headerCfg.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headerCfg.key ? order : false}
              >
                <TableSortLabel
                  disabled={!headerCfg.sortable}
                  active={orderBy === headerCfg.key}
                  direction={orderBy === headerCfg.key ? order : 'asc'}
                  onClick={createSortHandler(headerCfg.key)}
                >
                  {headerCfg.label}
                  {orderBy === headerCfg.key ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            );
          }
        })}
      </TableRow>
    </TableHead>
  );
};

export default StandardSortableHeaders;
